import styled from 'styled-components';

export const Container = styled.div``;

export const Footer = styled.div`
  margin: 4.1rem 0 2rem;
`;
